import { useState } from 'react';

function useModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    function closeModal(reason?: 'backdropClick' | 'escapeKeyDown') {
        if (reason && reason === 'backdropClick') {
            return;
        }

        setIsModalOpen(false);
    }

    function openModal() {
        setIsModalOpen(true);
    }

    return { isModalOpen, openModal, closeModal };
}

export default useModal;
